import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Card, CardContent, Typography, Grid } from '@material-ui/core'
import formatCurrency from '../../../utils/formatCurrency'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#4241BF',
    color: '#fff',
    borderRadius: 12,
    minWidth: 250,
    textAlign: 'center',
  },
  label: {
    fontSize: 16,
  },
  value: {
    fontSize: 20,
    marginTop: theme.spacing(1),
  },
}))

const BudgetCards = props => {
  const classes = useStyles()

  return (
    <Grid
      style={{ marginTop: '20px' }}
      container
      spacing={4}
      justify="center"
      data-testid="wip.budgetCards"
    >
      <Grid item>
        <Card className={classes.root} data-testid="wip.budgetCard.monthly">
          <CardContent>
            <Typography className={classes.label}>Monthly Project Budget</Typography>
            <Typography className={classes.value}>
              {formatCurrency(props.budget, props.currency)}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item>
        <Card className={classes.root} data-testid="wip.budgetCard.pacing">
          <CardContent>
            <Typography className={classes.label}>Pacing</Typography>
            <Typography className={classes.value}>
              {formatCurrency(props.pacing, props.currency)}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default BudgetCards
